// /components/Media/Media.tsx
import React from 'react';
import MediaArticles from '../../data/Media';
import Card from '../Card/Card';
import './Media.styles.scss';

// Utility function to format the date
const formatHelper = (publication: string, date: string): string => {
  const formattedDate = new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
  return `${publication} - ${formattedDate}`;
};

const Media: React.FC = () => {
  return (
    <div className="media-wrapper">
      {MediaArticles.map((article) => (
        <Card
          key={article.id}
          image={article.image}
          imageURL={article.url}
          imageAlt={article.imageAlt}
          headline={article.headline}
          headlineURL={article.url}
          helper={formatHelper(article.publication, article.date)} // Combine publication and formatted date
          subhead={article.subhead}
          btnLabel="Read more"
          btnURL={article.url}
          id={article.id}
          type="media"
          className="media-card action-on-view action-fade-in"
        />
      ))}
    </div>
  );
};

export default Media;
